
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

interface AnimatedCTAButtonProps {
  to: string;
  children: React.ReactNode;
  variant?: "default" | "outline";
  animationDirection: "left" | "right";
  delay?: number;
}

export default function AnimatedCTAButton({ 
  to, 
  children, 
  variant = "default",
  animationDirection,
  delay = 0
}: AnimatedCTAButtonProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  const animationClass = animationDirection === "left" 
    ? "translate-x-[-100px] opacity-0" 
    : "translate-x-[100px] opacity-0";

  const visibleClass = "translate-x-0 opacity-100";

  return (
    <div 
      className={`transition-all duration-700 ease-out ${
        isVisible ? visibleClass : animationClass
      }`}
    >
      <Button size="lg" variant={variant} asChild>
        <Link to={to}>{children}</Link>
      </Button>
    </div>
  );
}
